import { Container, Copyright, Socials } from './styles';
import { SocialLink, socials } from 'data';
import { Social } from 'components';
import { useTranslation } from 'next-i18next';

export const Footer = () => {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <Container>
      <Socials>
        {socials.map((item: SocialLink, index: number) => {
          const { link, type } = item;
          return (
            <Social
              color='--text_light'
              key={index}
              link={link}
              type={type}
            />
          );
        })}
      </Socials>
      <Copyright>© {currentYear} Nadine Pesso</Copyright>
    </Container>
  );
};
